import { useSEO } from "../lib/seo";
import { COMPANY } from "../data/content";

const LegalPage = () => {
  useSEO("Mentions légales — BÂTI 360", "Mentions légales du site BÂTI 360, entreprise de rénovation tous corps d'état à Chauconin-Neufmontiers.");
  return (
    <div className="bg-white pb-24 pt-40">
      <div className="mx-auto max-w-3xl px-5">
        <h1 className="font-display text-4xl font-extrabold tracking-tight text-bati-ink">Mentions légales</h1>

        <h2 className="mt-10 font-display text-xl font-bold text-bati-blue">Éditeur du site</h2>
        <p className="mt-3 text-sm leading-relaxed text-bati-ink/70">
          {COMPANY.name}<br />
          {COMPANY.address}, {COMPANY.city}<br />
          Téléphone : {COMPANY.phone}<br />
          E-mail : {COMPANY.email}<br />
          SIRET : [à compléter]<br />
          Directeur de la publication : [à compléter]
        </p>

        <h2 className="mt-10 font-display text-xl font-bold text-bati-blue">Hébergement</h2>
        <p className="mt-3 text-sm leading-relaxed text-bati-ink/70">
          Ce site est hébergé par Emergent — [adresse de l'hébergeur à compléter].
        </p>

        <h2 className="mt-10 font-display text-xl font-bold text-bati-blue">Propriété intellectuelle</h2>
        <p className="mt-3 text-sm leading-relaxed text-bati-ink/70">
          L'ensemble des contenus du site (textes, photographies, logo, éléments graphiques) est la propriété exclusive de {COMPANY.name}, sauf mention contraire. Toute reproduction, même partielle, est interdite sans autorisation préalable écrite.
        </p>

        <h2 className="mt-10 font-display text-xl font-bold text-bati-blue">Photographies</h2>
        <p className="mt-3 text-sm leading-relaxed text-bati-ink/70">
          Certaines photographies de chantier présentées sur ce site sont des visuels d'illustration en attente de remplacement par les réalisations réelles de {COMPANY.name}.
        </p>

        <h2 className="mt-10 font-display text-xl font-bold text-bati-blue">Crédits</h2>
        <p className="mt-3 text-sm leading-relaxed text-bati-ink/70">
          Design et développement : site conçu pour {COMPANY.name}. Photographies d'illustration : Unsplash et Pexels.
        </p>
      </div>
    </div>
  );
};

export default LegalPage;
